import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  getHealthcareData,
  getLeadsPool,
  getSupportedLanguages,
  patchLeadsPool,
  putHealthcareData,
  putSupportedLanguages,
} from '/redux/action/coach.action';
import {
  hasHealthcareData,
  hasHealthcareError,
  hasLeadsPool,
  hasLeadsPoolError,
  hasSupportedLanguages,
  hasSupportedLanguagesError,
  healthcareData,
  healthcareProvider,
  isHealthcareLoading,
  isHealthcareSaving,
  isLeadsPoolLoading,
  isLeadsPoolSaving,
  isSupportedLanguagesLoading,
  isSupportedLanguagesSaving,
  leadsPoolOptIn,
  supportedLanguages,
  supportedLanguagesList,
} from '/redux/selector/coach.selector';

import {ProfileBusinessSectionContainerComponent} from './ProfileBusinessSectionContainer';
import type {
  HealthcareApiData,
  LeadsPoolPayload,
  SupportedLanguagesPayload,
} from './ProfileBusinessSectionContainer.types';

const mapStateToProps = createStructuredSelector({
  leadsPoolOptIn,
  isLeadsPoolSaving,
  isLeadsPoolLoading,
  hasLeadsPool,
  hasLeadsPoolError,

  supportedLanguages,
  isSupportedLanguagesLoading,
  isSupportedLanguagesSaving,
  hasSupportedLanguages,
  supportedLanguagesList,
  hasSupportedLanguagesError,

  healthcareData,
  healthcareProvider,
  isHealthcareLoading,
  isHealthcareSaving,
  hasHealthcareData,
  hasHealthcareError,
});

const mapDispatchToProps = (dispatch: any) => ({
  getLeadsPool: () => dispatch(getLeadsPool({})),
  getSupportedLanguages: () => dispatch(getSupportedLanguages({})),
  getHealthcareData: () => dispatch(getHealthcareData({})),
  patchLeadsPool: (payload: LeadsPoolPayload) =>
    dispatch(patchLeadsPool(payload)),
  putSupportedLanguages: (payload: SupportedLanguagesPayload) =>
    dispatch(putSupportedLanguages(payload)),
  putHealthcareData: (payload: HealthcareApiData) =>
    dispatch(putHealthcareData(payload)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileBusinessSectionContainerComponent);
